import { render, staticRenderFns } from "./editOnboardedCompanyDocumentsComponent.vue?vue&type=template&id=633b0609&"
import script from "./editOnboardedCompanyDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./editOnboardedCompanyDocumentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./editOnboardedCompanyDocumentsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports